module.exports = __webpack_public_path__ + "img/erc.1f8b2cd7.png";